<template lang="pug">
    div
      el-row(:gutter="20").margin.mb-20
        el-col.inputDiv(:span="12")
          app-label(label="Estado", :required="true")
          el-select.full-width(v-model="informacaoLocalizacao.estado" placeholder="Selecione o estado" @change="changeEstado")
            el-option(v-for="estado in estadosBr" :key="estado.codigo" :label="estado.nome" :value="estado.codigo")
        el-col.inputDiv(:span="12", v-if="informacaoLocalizacao.municipio && informacaoLocalizacao.municipio !== ''")
          app-label(label="Município", :required="true")
          el-select.full-width(v-model="idSelecionado" placeholder="Selecione o município" @change="changeMunicipio")
            el-option(v-for="item in municipios" :key="item.id" :label="item.nome" :value="item.id")
      el-row(:gutter="20").margin.mb-20
        validation-provider(v-slot="{ errors }", name="Georreferenciamento/Geometria").mt-20
          mapa-analise-geomensor(
            v-model="informacaoLocalizacao.geometrias",
            :localizacoes="informacaoLocalizacao.geometrias",
            :tipoCadastro="'UC'",
            name="Geometria",
            idMapa="mapaAnaliseGeomensor",
            :errors="errors"
            :addOrtoFotos="true"
            @shapefileUploaded="setShapefile"
            @shapefileRemoved="removeShapefile"
          )
  </template>

<script>
import MapaAnaliseGeomensor from '@/screens/analise/components/MapaAnaliseGeomensor'
import AppLabel from '@/components/AppLabel'
import estadosBr from '@/constants/estados'
import { mapActions } from 'vuex'

export default {
  components: {
    MapaAnaliseGeomensor,
    AppLabel
  },

  props: {
    localizacao: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      estadosBr,
      municipios: [],
      idSelecionado: null,
      informacaoLocalizacao: { ...this.localizacao },
      optionsEsfera: [
        { value: 'Federal', label: 'Federal' },
        { value: 'Estadual', label: 'Estadual' },
        { value: 'Municipal', label: 'Municipal' }
      ],
      optionsCategoria: [
        { value: 'ProtecaoIntegral', label: 'UCs de proteção integral' },
        { value: 'EstacaoEcologica', label: 'Estação ecológica' },
        { value: 'ReservaBiologica', label: 'Reserva biológica' },
        { value: 'ParqueNacional', label: 'Parque nacional' },
        { value: 'MonumentoNatural', label: 'Monumento Natural' },
        { value: 'RefugioVidaSilvestre', label: 'Refúgio da vida silvestre' },
        { value: 'APA', label: 'Área de proteção ambiental (APA)' },
        { value: 'ARIE', label: 'Área de relevante interesse ecológico (ARIE)' },
        { value: 'FLONA', label: 'Floresta nacional (FLONA)' },
        { value: 'RESEX', label: 'Reserva extrativista (RESEX)' },
        { value: 'ReservaFauna', label: 'Reserva de fauna' },
        { value: 'RDS', label: 'Reserva de desenvolvimento sustentável (RDS)' },
        { value: 'RPPN', label: 'Reserva particular do patrimônio natural (RPPN)' }
      ]
    }
  },
  async mounted () {
    this.informacaoLocalizacao.municipio = this.localizacao?.municipio?.id ? this.localizacao.municipio : { id: null }
    if (this.informacaoLocalizacao.estado) {
      this.municipios = await this.getMunicipiosByUf(this.informacaoLocalizacao.estado)
    }
  },
  methods: {
    ...mapActions({
      getMunicipiosByUf: 'municipios/findMunicipiosByUf'
    }),
    changeMunicipio () {
      this.informacaoLocalizacao.municipio = this.municipios.find(m => m.id === this.idSelecionado)
    },
    async changeEstado () {
      this.informacaoLocalizacao.municipio = {id: null}
      this.municipios = await this.getMunicipiosByUf(this.informacaoLocalizacao.estado)
    },
    setShapefile ({fileName, fileKey}) {
    },
    removeShapefile () {
    }
  },
  watch: {
    informacaoLocalizacao: {
      handler (newVal) {
        this.$emit('update:localizacao', newVal)
      },
      deep: true
    }
  }
}
</script>

</script>
  <style lang="scss">
  @import "@/assets/styles/_variables.scss";

  .mb-20 {
    margin-bottom: 50px;
  }
  .mt-20 {
    margin-top: 20px;
  }
  .none {
    border: none;
  }
  .ml-15 {
    margin-left: 15px;
  }
  </style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppFormularioLocalizacao.vue